/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function isEmpty(object) {
    return !Object.keys(object).length;
}
